/* eslint-disable no-undef */
import $ from 'jquery'

window.jQuery = $
window.$ = $

function sortProducts() {
  const categoryItems = document.querySelectorAll('.js-facet-list-item')

  function trigger() {
    const itemSlug = this.getAttribute('data-slug')
    const itemFacet = this.getAttribute('data-facet')

    // FWP.facets['meta'] = []
    FWP.reset()
    FWP.facets[itemFacet] = [itemSlug]
    FWP.set_hash()
    FWP.fetch_data()
  }

  categoryItems.forEach(item => item.addEventListener('click', trigger))
}

export { sortProducts }

function triggerFacetChildren() {
  const topTerms = document.querySelectorAll('.c-top-level-term-item')
  const secondTerms = document.querySelectorAll('.c-second-level-term > span')

  function showChildren(e) {
    e.preventDefault()

    topTerms.forEach(term => {
      term.parentNode.classList.remove('active')
    })

    e.currentTarget.parentNode.classList.add('active')

    secondTerms.forEach(term => {
      term.classList.remove('active')
    })
  }

  function showSecondChildren(e) {
    e.preventDefault()

    secondTerms.forEach(term => {
      term.classList.remove('active')
    })

    e.currentTarget.classList.add('active')
  }

  topTerms.forEach(term => term.addEventListener('click', showChildren))
  secondTerms.forEach(term =>
    term.addEventListener('click', showSecondChildren),
  )

  function checkURL() {
    const facets = document.querySelectorAll('[data-slug]')

    facets.forEach(facet => {
      const facetVal = facet.getAttribute('data-slug')

      if (window.location.href.indexOf(facetVal) !== -1) {
        facet.parentNode.classList.add('active')

        const facetParentVal = facet.getAttribute('data-parent')

        if (facetParentVal !== null) {
          const secondLevelFacet = document.querySelector(
            `[data-slug=${facetParentVal}]`,
          )
          secondLevelFacet.parentNode.classList.add('active')

          facet.classList.add('active')
        }
      }
    })
  }

  checkURL()
}

export { triggerFacetChildren }

function setDivHeights() {
  const mainCat = document.querySelector(
    '.c-product-filters > .c-product-categories-list',
  )
  const secondaryCats = document.querySelectorAll(
    '.c-product-categories-list--children',
  )
  const productFilters = document.querySelector('.c-product-filters')

  const heights = []

  secondaryCats.forEach(item => {
    // eslint-disable-next-line no-param-reassign
    item.style.top = `${mainCat.offsetHeight}px`

    heights.push(item.offsetHeight)
  })

  const largest = Math.max(...heights)
  if (largest > '0') {
    productFilters.style.marginBottom = `${largest + 20}px`
  }
}

export { setDivHeights }

function facetLoader() {
  $(document).on('facetwp-refresh', function loader() {
    if (FWP.loaded && !FWP.is_load_more) {
      $('.facetwp-template').prepend(
        `<div class="c-loading"><img src="${wordpress_localized_variables.theme_url}/dist/logos/standard_logo_s.svg" alt="loading logo"></div>`,
      )
    }
  })

  $(document).on('facetwp-loaded', function loaded() {
    setDivHeights()
  })
}

export { facetLoader }
